import React, { useCallback, useMemo, useState } from "react";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";
import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import ActivitySort from "@app/component/activity/ActivitySort/ActivitySort";
import useView from "@app/component/view/utils/useView";
import { activityListViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import getActivityStatusOptionByFilter from "@app/util/activity/getActivityStatusOptionByFilter";

interface Props {}

const QuickSort: React.FC<Props> = () => {
  const { updateViewStateAndFetch, viewState } = useView();
  const [field, setField] = useState<IField>(viewState.sort[0].field);
  const [order, setOrder] = useState<SortOrder>(viewState.sort[0].order);
  const {
    viewState: { filter },
  } = useView();

  const activityStatusOption: ActivityStatusOption = useMemo(
    () => getActivityStatusOptionByFilter(filter),
    [filter]
  );

  const handleApply = useCallback(() => {
    updateViewStateAndFetch({ sort: [{ field, order }] });
  }, [order, field, updateViewStateAndFetch]);

  const handleClick = useCallback(() => {
    activityListViewAnalytics.clicked([viewState.sort[0].field.displayName]);
  }, [viewState.sort]);

  return (
    <ActivitySort
      activityStatusOption={activityStatusOption}
      field={field}
      onApply={handleApply}
      onChangeField={setField}
      onChangeOrder={setOrder}
      onClick={handleClick}
      order={order}
      size="middle"
    />
  );
};

export default QuickSort;
